import { render } from "./CompInputRemarks.vue?vue&type=template&id=cca80294&scoped=true"
import script from "./CompInputRemarks.vue?vue&type=script&lang=js"
export * from "./CompInputRemarks.vue?vue&type=script&lang=js"

import "./CompInputRemarks.vue?vue&type=style&index=0&id=cca80294&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca80294"]])

export default __exports__